export const formatCurrency = (value) => {
  // Convert null/undefined/NaN to 0
  const num = Number(value) || 0;

  return num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
};
